export default class CookieHelper {
  get jar() {
    return document.cookie.split(/;\s*/).reduce(
      /**
       * Construit un objet contenant tous les cookies définis dans `document.cookie` et disponibles pour lecture.
       * NOTE:  Les cookies http-only et secure ne peuvent être retournés
       * même s'ils sont visibles dans la console d'inspection d'un fureteur.
       */
      (jar, cookie) => {
        // Regex effectue la séparation sur le premier "=" seulement.  Le caractère peut ainsi être
        // utilisé à l'intérieur de la valeur
        const [name, value] = cookie.split(/=(.*)/) as [name: string, value?: string | undefined];
        let parsedValue = value;
        try {
          parsedValue = value ? JSON.parse(value) : '';
        } catch {
          // valeur n'est pas au format JSON
        }
        return { ...jar, [name]: parsedValue };
      },
      {},
    );
  }

  /**
   * Retourne la valeur contenue dans un cookie lorsque celui-ci est existant
   */
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */ // any: valeur peut représenter n'importe quoi
  getCookie = (name: string, defaultValue = null): any => this.jar[name as keyof unknown] ?? defaultValue;

  /**
   * Ajoute un nouveau cookie
   */
  setCookie = (name: string, value: string | object, domain = '', maxAge = 0, path = '/') => {
    const cookie = {
      name: `${name}=${JSON.stringify(value)}`,
      domain: `domain=${domain || document.location.hostname}`,
      expires: maxAge ? `expires=${new Date(Date.now() + maxAge * 1000).toUTCString()}` : '',
      path: `path=${path}`,
    };
    document.cookie = Object.values(cookie).filter(Boolean).join('; ');
  };
}
